class SettingsController {
  constructor($timeout) {
    'ngInject';

    this.$timeout = $timeout;
  }

  $onInit() {
    $('.cancel').click(function() {
      $('#gAuthSuccess').hide();
      $('#gAuthWarning').hide();
    });
  }
}

export default SettingsController;


// WEBPACK FOOTER //
// ./client/app/pages/settings/settings.controller.js